import Box from '@mui/material/Box';
import { HighlightedTeamProvider } from 'src/contexts/HighlightedTeamContext';
import { LeaderboardTitle } from 'src/components/leaderboards/LeaderboardTitle';
import { MatchDetailsProvider } from 'src/components/tournaments/match/details/MatchDetailsProvider';
import { BracketBoard } from 'src/components/tournaments/brackets/BracketBoard';
import { TabHeat } from 'src/components/tournaments/brackets/HeatsBracketTab';
import { calculateActiveRound } from 'src/util/bracket/calculateActiveRound';
import { formatPrize } from 'functions/src/types/firestore/Game/util/formatPrize';
import { memo } from 'react';

export type BracketBoardContainerProps = {
  bracket?: TabHeat;
  bracketLoser?: TabHeat;
  isGrandFinal?: boolean;
};

export const BracketBoardContainer = memo(
  function BracketBoardContainerUnmemoized({
    bracket,
    bracketLoser,
    isGrandFinal,
  }: BracketBoardContainerProps) {
    const { title, prizes, rounds } = bracket || {};
    const roundsLoser = bracketLoser?.rounds;
    const roundActive = calculateActiveRound(rounds);
    const roundActiveLoser = calculateActiveRound(roundsLoser);
    const roundPrizes = prizes?.map((prize) => {
      return formatPrize(prize);
    });
    return (
      <HighlightedTeamProvider>
        <>
          {title && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <LeaderboardTitle title={title} />
            </Box>
          )}
          {!!rounds?.length && (
            <MatchDetailsProvider rounds={rounds}>
              <BracketBoard
                {...{
                  rounds,
                  activeRound: roundActive?.activeRoundIndex,
                  activeRoundProgress: roundActive?.activeRoundProgress,
                  roundPrizes,
                }}
              />
            </MatchDetailsProvider>
          )}

          {!!roundsLoser?.length && (
            <MatchDetailsProvider rounds={roundsLoser}>
              <BracketBoard
                {...{
                  rounds: roundsLoser,
                  activeRound: roundActiveLoser?.activeRoundIndex,
                  activeRoundProgress: roundActiveLoser?.activeRoundProgress,
                  isLoserBracket: true,
                  isGrandFinal,
                  roundPrizes,
                }}
              />
            </MatchDetailsProvider>
          )}
        </>
      </HighlightedTeamProvider>
    );
  },
);
